(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodDropdownButton', sodDropdownButton);

    function sodDropdownButton($document) {
        return {
            restrict: 'E',
            controller: sodDropdownButtonCtrl,
            controllerAs: 'vm',
            bindToController: true,
            transclude: true,
            templateUrl: 'common/components/sod-dropdown-button',
            scope: {
                actionList: '=?',
                customActionList: '=?',
                dir: '@?',
                template: '=?',
            },
            link: sodDropdownButtonLink
        };

        function sodDropdownButtonLink(scope, elem, attr) {
            var vm = scope.vm;
                //dropdown = elem.find('.dropdown');

            elem.on('click', function(e) {
                e.preventDefault();
                vm.toggle();
            });

            $document.on('click', function(e) {
                var parents = angular.element(e.target).parents('#' + attr.id);
                if (parents.length == 0) {
                    if (vm.toggleState) {
                        vm.toggle();
                    }
                }
            });

            // trigger when li is clicked;

            scope.$on('$destroy', function() {
                elem.off('click');
            });
        }
    }

    function sodDropdownButtonCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            vm.toggleState = false;
            vm.toggle = toggle;
        }

        function toggle() {
            vm.toggleState = !vm.toggleState;
            $scope.$apply();
        }
    }
})();